export enum ScenarioType {
  Scenario = "scenario",
  CustomScenario = "customScenario",
}
